<template>
  <nav class="nav">
    <ul class="nav-menu">
      <router-link 
        v-for="(item, index) in navList" 
        :key="index" 
        :to="item.path">
        <li
          class="nav-menu-item"
          :class="activeName === item.name ? 'active-title' : 'normal-title'"
        >
          {{item.text}}
        </li>
      </router-link>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    navList: Array
  },
  computed: {
    activeName() {
      return this.$route.name
    }
  }
}
</script>
<style scoped>
.nav-menu-item {
  color: #fff;
}
.nav-menu-item {
  float: left;
  font-size: 22px;
  padding-bottom: 5px;
  cursor: pointer;
  height: 70px;
  line-height: 70px;
  padding: 0 20px;
}
.active-title {
  font-weight: 600;
  background: rgba(0, 0, 0, .1);
}
.normal-title {
  font-weight: 400;
}
</style>